import { differenceInDays, format, isToday, isYesterday } from 'date-fns';

export function getTransactionDate(creationDate: string, withDate?: boolean) {
  const date = new Date(creationDate);
  if (withDate) {
    if (isToday(date)) {
      return `Today at ${format(date, 'HH:mm')}`;
    } else if (isYesterday(date)) {
      return `Yesterday at ${format(date, 'HH:mm')}`;
    } else if (differenceInDays(new Date(), date) < 7) {
      // If the date is within the last 7 days, use the relative format
      return format(date, "'Last' eeee 'at' HH:mm");
    } else {
      // If the date is more than 7 days ago, use a different format
      return format(date, 'do MMMM yyyy, HH:mm');
    }
  }
  return format(date, 'HH:mm');
}
